import { Button, ButtonTheme } from '@cian/button-component';
import * as React from 'react';

import { IAgentSchema, IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { trackFavoriteClick } from '../tracking';

import * as styles from './index.css';

export interface IFavoriteButtonStoreProps {
  checked: boolean;
  agent: IAgentSchema | null;
  offer: IOfferSchema;
}

export interface IFavoriteButtonDispatchProps {
  changeFavorite(): void;
}

export type IFavoriteButtonProps = IFavoriteButtonStoreProps & IFavoriteButtonDispatchProps;

export function FavoriteButton(props: IFavoriteButtonProps) {
  return (
    <Button
      onClick={() => {
        props.changeFavorite();

        trackFavoriteClick(props.offer, props.agent, !props.checked);
      }}
      className={styles['button']}
      theme={ButtonTheme.Ghost}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14.004 14"
        width="14"
        height="14"
      >
        {/* tslint:disable-next-line:max-line-length */}
        <path stroke="#E84260" fill={props.checked ? '#e84260' : 'none'} strokeWidth="2" d="M6.99 11.72L1.825 6.677C.727 5.582.725 3.805 1.82 2.707l.015-.015c1.118-1.08 2.962-1.08 4.092.014l.36.35.67.648.694-.62.394-.35.03-.028c1.13-1.095 2.973-1.095 4.104 0 1.1 1.093 1.103 2.87.01 3.968l-.015.015-5.182 5.03z" />
      </svg>
    </Button>
  );
}
